import { createFileRoute } from '@tanstack/react-router';
import { AppointeeTenantDetailRoute } from '@/pages/admin/appointee/detail-route';

/**
 * Dettaglio del tenant delegato: pannello sopra la pagina dell'incaricato,
 * che il layout tiene già montata (il clic su una riga non porta altrove).
 */
export const Route = createFileRoute('/admin/_layout/appointee/_layout/$id')({
  component: AppointeeTenantDetailRouteComponent,
});

function AppointeeTenantDetailRouteComponent() {
  const { id } = Route.useParams();

  return <AppointeeTenantDetailRoute tenantId={id} />;
}
